import { useEffect, useState } from 'react';
import axios from 'axios';
import config from '../config';

const PatientList = ({ onSelect }) => {
  const [patients, setPatients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [patientToDelete, setPatientToDelete] = useState(null);

  const fetchPatients = () => {
    axios.get(`${config.API_BASE_URL}${config.ADMIN.PATIENTS}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }).then(res => setPatients(res.data));
  };

  useEffect(fetchPatients, []);

  const confirmDelete = (p, e) => {
    e.stopPropagation();
    setPatientToDelete(p);
    setShowModal(true);
  };

  const deletePatient = async () => {
    if (!patientToDelete) return;

    await axios.delete(
      `${config.API_BASE_URL}${config.ADMIN.DELETE_PATIENT(patientToDelete.patientID)}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    );

    setShowModal(false);
    setPatientToDelete(null);
    fetchPatients();
  };

  return (
    <div style={sidebar}>
      <h3>Users</h3>

      {patients.map(p => (
        <div
          key={p.patientID}
          style={item}
          onClick={() => onSelect && onSelect(p)}
        >
          <span>
            {p.firstName} {p.lastName}
          </span>

          <button
            style={deleteBtn}
            onClick={(e) => confirmDelete(p, e)}
          >
            ✖
          </button>
        </div>
      ))}

      {showModal && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3>Delete Patient?</h3>
            <p>Are you sure you want to permanently delete {patientToDelete?.firstName}?</p>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button style={cancelBtn} onClick={() => setShowModal(false)}>Cancel</button>
              <button style={confirmBtn} onClick={deletePatient}>Delete</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const sidebar = { padding:20, background:'#f4f4f4' };
const item = {
  padding:10,
  marginBottom:8,
  background:'#fff',
  cursor:'pointer',
  display:'flex',
  justifyContent:'space-between',
  alignItems:'center'
};
const deleteBtn = {
  background:'red',
  color:'#fff',
  border:'none',
  cursor:'pointer',
  borderRadius: '4px',
  padding: '4px 8px'
};

const modalOverlay = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
};
const modalContent = {
  background: '#fff', padding: '24px', borderRadius: '8px', minWidth: '300px', textAlign: 'center'
};
const cancelBtn = {
  flex: 1, padding: '8px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '4px', background: '#f9f9f9'
};
const confirmBtn = {
  flex: 1, padding: '8px', cursor: 'pointer', border: 'none', borderRadius: '4px', background: 'red', color: '#fff'
};

export default PatientList;

